export function usePrint() {
    async function copyCSS(docWindow) {
        const body = docWindow.documentElement.querySelector("body");
        if (body.querySelector("#copiedStyles"))
            return;
        const utf = document.createElement("meta");
        utf.setAttribute("charset", "utf-8");
        docWindow.head.append(utf);
        const styleSections = document.createElement("div");
        styleSections.id = "copiedStyles";
        styleSections.style.display = "none";
        // Copy CSS to iframe
        Array.from(document.head.children).forEach(head => {
            if (head.tagName == "STYLE") {
                docWindow.head.append(head.cloneNode(true));
            }
            else if (head.type == "text/css") {
                styleSections.append(head.cloneNode(true));
            }
            else if (head.rel == "stylesheet") {
                docWindow.head.append(head.cloneNode(true));
            }
        });
        body.append(styleSections);
        // Delay a bit, should be fix for missing CSS issue at first launch
        await new Promise(r => setTimeout(r, 1000));
    }
    async function startPrint({ elementId, dataElementId, element, iframe }) {
        const docWindow = iframe.contentDocument;
        await copyCSS(docWindow);
        const wrapper = document.createElement("div");
        wrapper.classList.add("vuetify-overwrite-app");
        wrapper.classList.add("fipa-app");
        const content = document.createElement("div");
        content.setAttribute("id", "content");
        content.classList.add("v-application");
        let mainContent = null;
        if (elementId) {
            mainContent = document.querySelector(elementId);
        }
        else if (dataElementId) {
            mainContent = document.querySelector(`[data-print-id="${dataElementId}"]`);
        }
        else if (element) {
            mainContent = element();
        }
        content.append(mainContent.cloneNode(true));
        wrapper.append(content);
        docWindow.documentElement.querySelector("body").prepend(content);
        let imgFullyLoaded = mainContent.querySelectorAll("img").length > 0 ? false : true;
        let cooldown = null;
        do {
            const imgs = docWindow.documentElement.querySelectorAll("img");
            cooldown = new Promise(resolve => {
                setTimeout(() => {
                    resolve(null);
                }, 500);
            });
            await cooldown;
            imgFullyLoaded = !Array.from(imgs).some(x => {
                return x.complete === false;
            });
        } while (imgFullyLoaded == false);
        docWindow.defaultView.print();
        docWindow.documentElement
            .querySelector("body")
            .childNodes.forEach(el => el.remove());
    }
    return {
        startPrint
    };
}
